import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../lib/i18n';

/**
 * Footer with the legal links DSGVO + § 5 ECG require to be reachable
 * from every page. Drop in anywhere. Works inside `AppLayout` and
 * standalone (legal-page wrapper, landing page, etc.).
 */
export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-[#e3dccb] mt-12 py-6 px-4 text-xs text-[#8a8474]">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <p>
          © {new Date().getFullYear()} Real Content · <a href="mailto:support@real-content.at" className="hover:text-[#4a463b]">support@real-content.at</a>
        </p>
        <nav className="flex flex-wrap gap-x-4 gap-y-1">
          <Link to="/impressum" className="hover:text-[#4a463b]">{t('footer.impressum') || 'Impressum'}</Link>
          <Link to="/datenschutz" className="hover:text-[#4a463b]">{t('footer.datenschutz') || 'Datenschutz'}</Link>
          <Link to="/agb" className="hover:text-[#4a463b]">{t('footer.agb') || 'AGB'}</Link>
          <Link to="/widerrufsrecht" className="hover:text-[#4a463b]">{t('footer.widerruf') || 'Widerrufsrecht'}</Link>
          <Link to="/faq" className="hover:text-[#4a463b]">{t('footer.faq') || 'FAQ'}</Link>
        </nav>
      </div>
    </footer>
  );
}
